import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Full-page loading screen shown while auth state is being restored.
 * Prevents white screen on reload and makes it clear the app is loading.
 */
export default function AuthLoadingScreen() {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.paper',
        color: 'text.primary',
        zIndex: 2000
      }}
    >
      <CircularProgress size={48} thickness={4} sx={{ mb: 2 }} />
      <Typography variant="body1" color="text.secondary">
        Restoring session...
      </Typography>
    </Box>
  );
}
